import React, { useEffect, useState } from "react";
import axios from "axios";
import Input from "../../components/Input";
import { toast } from "react-toastify";
import Autosuggest from "react-autosuggest";
import "./style.scss";

import bpLogo from "../../assets/bp-logo.svg";
import bpWebImg from "../../assets/qrPoster.jpg";
import cross from "../../assets/cross.svg";
import bpblk from "../../assets/bharatPe-blk.svg";

import appStoreIcon from "../../assets/app-store.png";
import googlePlayIcon from "../../assets/google-play.png";
import verifiedIcon from "../../assets/verified.svg";
import oneQrIcon from "../../assets/one-qr.svg";
import orderQrIcon from "../../assets/order-qr.svg";
import instantDeliveryIcon from "../../assets/instant-delivery.svg";
import facebookIcon from "../../assets/facebook-icon.svg";
import instagramIcon from "../../assets/instagram-icon.svg";
import linkedinIcon from "../../assets/linkedin-icon.svg";
import twitterIcon from "../../assets/twitter-icon.svg";

const cities = [
  "Mumbai",
  "Pune",
  "Nagpur",
  "Thane",
  "Nashik",
  "Kalyan-Dombivali",
  "Vasai-Virar",
  "Solapur",
  "Mira-Bhayandar",
  "Bhiwandi",
  "Amravati",
  "Nanded-Waghala",
  "Sangli",
  "Malegaon",
  "Akola",
  "Latur",
  "Dhule",
  "Ahmednagar",
  "Ichalkaranji",
  "Parbhani",
  "Panvel",
  "Yavatmal",
  "Achalpur",
  "Osmanabad",
  "Nandurbar",
  "Satara",
  "Wardha",
  "Udgir",
  "Aurangabad",
  "Amalner",
  "Akot",
  "Pandharpur",
  "Shrirampur",
  "Parli",
  "Washim",
  "Ambejogai",
  "Manmad",
  "Ratnagiri",
  "Uran Islampur",
  "Pusad",
  "Sangamner",
  "Shirpur-Warwade",
  "Malkapur",
  "Wani",
  "Lonavla",
  "Talegaon Dabhade",
  "Anjangaon",
  "Umred",
  "Palghar",
  "Shegaon",
  "Ozar",
  "Phaltan",
  "Yevla",
  "Shahade",
  "Vita",
  "Umarkhed",
  "Warora",
  "Pachora",
  "Tumsar",
  "Manjlegaon",
  "Sillod",
  "Arvi",
  "Nandura",
  "Vaijapur",
  "Wadgaon Road",
  "Sailu",
  "Murtijapur",
  "Tasgaon",
  "Mehkar",
  "Yawal",
  "Pulgaon",
  "Nilanga",
  "Wai",
  "Umarga",
  "Paithan",
  "Rahuri",
  "Nawapur",
  "Tuljapur",
  "Morshi",
  "Purna",
  "Satana",
  "Pathri",
  "Sinnar",
  "Uchgaon",
  "Uran",
  "Pen",
  "Karjat",
  "Manwath",
  "Partur",
  "Sangole",
  "Mangrulpir",
  "Risod",
  "Shirur",
  "Savner",
  "Sasvad",
  "Pandharkaoda",
  "Talode",
  "Shrigonda",
  "Shirdi",
  "Raver",
  "Mukhed",
  "Rajura",
  "Vadgaon Kasba",
  "Tirora",
  "Mahad",
  "Lonar",
  "Sawantwadi",
  "Pathardi",
  "Pauni",
  "Ramtek",
  "Mul",
  "Soyagaon",
  "Mangalvedhe",
  "Narkhed",
  "Shendurjana",
  "Patur",
  "Mhaswad",
  "Loha",
  "Nandgaon",
  "Warud",
  "Delhi",
  "New Delhi",
  "Bengaluru",
  "Hubli-Dharwad",
  "Belagavi",
  "Mangaluru",
  "Davanagere",
  "Ballari",
  "Tumkur",
  "Shivamogga",
  "Raayachuru",
  "Robertson Pet",
  "Kolar",
  "Mandya",
  "Udupi",
  "Chikkamagaluru",
  "Karwar",
  "Ranebennuru",
  "Ranibennur",
  "Ramanagaram",
  "Gokak",
  "Yadgir",
  "Rabkavi Banhatti",
  "Shahabad",
  "Sirsi",
  "Sindhnur",
  "Tiptur",
  "Arsikere",
  "Nanjangud",
  "Sagara",
  "Sira",
  "Puttur",
  "Athni",
  "Mulbagal",
  "Surapura",
  "Siruguppa",
  "Mudhol",
  "Sidlaghatta",
  "Shahpur",
  "Saundatti-Yellamma",
  "Wadi",
  "Manvi",
  "Nelamangala",
  "Lakshmeshwar",
  "Ramdurg",
  "Nargund",
  "Tarikere",
  "Malavalli",
  "Savanur",
  "Lingsugur",
  "Vijayapura",
  "Sankeshwara",
  "Madikeri",
  "Talikota",
  "Sedam",
  "Shikaripur",
  "Mahalingapura",
  "Mudalagi",
  "Muddebihal",
  "Pavagada",
  "Malur",
  "Sindhagi",
  "Sanduru",
  "Afzalpur",
  "Maddur",
  "Madhugiri",
  "Tekkalakote",
  "Terdal",
  "Mudabidri",
  "Magadi",
  "Navalgund",
  "Shiggaon",
  "Shrirangapattana",
  "Sindagi",
  "Sakaleshapura",
  "Srinivaspur",
  "Ron",
  "Mundargi",
  "Sadalagi",
  "Piriyapatna",
  "Adyar",
  "Ahmedabad",
  "Surat",
  "Vadodara",
  "Rajkot",
  "Bhavnagar",
  "Jamnagar",
  "Nadiad",
  "Porbandar",
  "Anand",
  "Morvi",
  "Mahesana",
  "Bharuch",
  "Vapi",
  "Navsari",
  "Veraval",
  "Bhuj",
  "Godhra",
  "Palanpur",
  "Valsad",
  "Patan",
  "Deesa",
  "Amreli",
  "Anjar",
  "Dhoraji",
  "Khambhat",
  "Mahuva",
  "Keshod",
  "Wadhwan",
  "Ankleshwar",
  "Savarkundla",
  "Kadi",
  "Visnagar",
  "Upleta",
  "Una",
  "Sidhpur",
  "Unjha",
  "Mangrol",
  "Viramgam",
  "Modasa",
  "Palitana",
  "Petlad",
  "Kapadvanj",
  "Sihor",
  "Wankaner",
  "Limbdi",
  "Mandvi",
  "Thangadh",
  "Vyara",
  "Padra",
  "Lunawada",
  "Rajpipla",
  "Vapi",
  "Umreth",
  "Sanand",
  "Rajula",
  "Radhanpur",
  "Mahemdabad",
  "Ranavav",
  "Tharad",
  "Mansa",
  "Umbergaon",
  "Talaja",
  "Vadnagar",
  "Manavadar",
  "Salaya",
  "Vijapur",
  "Pardi",
  "Rapar",
  "Songadh",
  "Lathi",
  "Adalaj",
  "Chhapra",
  "Hyderabad",
  "Warangal",
  "Nizamabad",
  "Karimnagar",
  "Ramagundam",
  "Khammam",
  "Mahbubnagar",
  "Mancherial",
  "Adilabad",
  "Suryapet",
  "Jagtial",
  "Miryalaguda",
  "Nirmal",
  "Kamareddy",
  "Kothagudem",
  "Bodhan",
  "Palwancha",
  "Mandamarri",
  "Koratla",
  "Sircilla",
  "Tandur",
  "Siddipet",
  "Wanaparthy",
  "Kagaznagar",
  "Gadwal",
  "Sangareddy",
  "Bellampalle",
  "Bhongir",
  "Vikarabad",
  "Jangaon",
  "Bhadrachalam",
  "Bhainsa",
  "Farooqnagar",
  "Medak",
  "Narayanpet",
  "Sadasivpet",
  "Yellandu",
  "Manuguru",
  "Kyathampalle",
  "Nagarkurnool",
  "Chennai",
  "Coimbatore",
  "Madurai",
  "Tiruchirappalli",
  "Salem",
  "Tirunelveli",
  "Tiruppur",
  "Ranipet",
  "Nagercoil",
  "Thanjavur",
  "Vellore",
  "Kancheepuram",
  "Erode",
  "Tiruvannamalai",
  "Pollachi",
  "Rajapalayam",
  "Sivakasi",
  "Pudukkottai",
  "Neyveli (TS)",
  "Nagapattinam",
  "Viluppuram",
  "Tiruchengode",
  "Vaniyambadi",
  "Theni Allinagaram",
  "Udhagamandalam",
  "Aruppukkottai",
  "Paramakudi",
  "Arakkonam",
  "Virudhachalam",
  "Srivilliputhur",
  "Tindivanam",
  "Virudhunagar",
  "Karur",
  "Valparai",
  "Sankarankovil",
  "Tenkasi",
  "Palani",
  "Pattukkottai",
  "Tirupathur",
  "Ramanathapuram",
  "Udumalaipettai",
  "Gobichettipalayam",
  "Thiruvarur",
  "Thiruvallur",
  "Panruti",
  "Namakkal",
  "Thirumangalam",
  "Vikramasingapuram",
  "Nellikuppam",
  "Rasipuram",
  "Tiruttani",
  "Nandivaram-Guduvancheri",
  "Periyakulam",
  "Pernampattu",
  "Vellakoil",
  "Sivaganga",
  "Vadalur",
  "Rameshwaram",
  "Tiruvethipuram",
  "Perambalur",
  "Usilampatti",
  "Vedaranyam",
  "Sathyamangalam",
  "Puliyankudi",
  "Nanjikottai",
  "Thuraiyur",
  "Sirkali",
  "Tiruchendur",
  "Periyasemur",
  "Sattur",
  "Vandavasi",
  "Tharamangalam",
  "Tirukkoyilur",
  "Oddanchatram",
  "Palladam",
  "Vadakkuvalliyur",
  "Tirukalukundram",
  "Uthamapalayam",
  "Surandai",
  "Sankari",
  "Shenkottai",
  "Vadipatti",
  "Sholingur",
  "Tirupathur",
  "Manachanallur",
  "Viswanatham",
  "Polur",
  "Panagudi",
  "Uthiramerur",
  "Thiruthuraipoondi",
  "Pallapatti",
  "Ponneri",
  "Lalgudi",
  "Natham",
  "Unnamalaikadai",
  "P.N.Patti",
  "Tharangambadi",
  "Tittakudi",
  "Pacode",
  "O' Valley",
  "Suriyampalayam",
  "Sholavandan",
  "Thammampatti",
  "Namagiripettai",
  "Peravurani",
  "Parangipettai",
  "Pudupattinam",
  "Pallikonda",
  "Sivagiri",
  "Punjaipugalur",
  "Padmanabhapuram",
  "Thirupuvanam",
  "Kolkata",
  "Siliguri",
  "Asansol",
  "Raghunathganj",
  "Kharagpur",
  "Naihati",
  "English Bazar",
  "Baharampur",
  "Hugli-Chinsurah",
  "Raiganj",
  "Jalpaiguri",
  "Santipur",
  "Balurghat",
  "Medinipur",
  "Habra",
  "Ranaghat",
  "Bankura",
  "Nabadwip",
  "Darjiling",
  "Purulia",
  "Arambagh",
  "Tamluk",
  "AlipurdUrban Agglomerationr",
  "Suri",
  "Jhargram",
  "Gangarampur",
  "Rampurhat",
  "Kalimpong",
  "Sainthia",
  "Taki",
  "Murshidabad",
  "Memari",
  "Paschim Punropara",
  "Tarakeswar",
  "Sonamukhi",
  "PandUrban Agglomeration",
  "Mainaguri",
  "Malda",
  "Panchla",
  "Raghunathpur",
  "Mathabhanga",
  "Monoharpur",
  "Srirampore",
  "Adra",
  "Jaipur",
  "Jodhpur",
  "Bikaner",
  "Udaipur",
  "Ajmer",
  "Bhilwara",
  "Alwar",
  "Bharatpur",
  "Pali",
  "Barmer",
  "Sikar",
  "Tonk",
  "Sadulpur",
  "Sawai Madhopur",
  "Nagaur",
  "Makrana",
  "Sujangarh",
  "Sardarshahar",
  "Ladnu",
  "Ratangarh",
  "Nokha",
  "Nimbahera",
  "Suratgarh",
  "Rajsamand",
  "Lachhmangarh",
  "Rajgarh (Churu)",
  "Nasirabad",
  "Nohar",
  "Phalodi",
  "Nathdwara",
  "Pilani",
  "Merta City",
  "Sojat",
  "Neem-Ka-Thana",
  "Sirohi",
  "Pratapgarh",
  "Rawatbhata",
  "Sangaria",
  "Lalsot",
  "Pilibanga",
  "Pipar City",
  "Taranagar",
  "Vijainagar, Ajmer",
  "Sumerpur",
  "Sagwara",
  "Ramganj Mandi",
  "Lakheri",
  "Udaipurwati",
  "Losal",
  "Sri Madhopur",
  "Ramngarh",
  "Rawatsar",
  "Rajakhera",
  "Shahpura",
  "Shahpura",
  "Raisinghnagar",
  "Malpura",
  "Nadbai",
  "Sanchore",
  "Nagar",
  "Rajgarh (Alwar)",
  "Sheoganj",
  "Sadri",
  "Todaraisingh",
  "Todabhim",
  "Reengus",
  "Rajaldesar",
  "Sadulshahar",
  "Sambhar",
  "Prantij",
  "Mount Abu",
  "Mangrol",
  "Phulera",
  "Mandawa",
  "Pindwara",
  "Mandalgarh",
  "Takhatgarh",
  "Lucknow",
  "Kanpur",
  "Firozabad",
  "Agra",
  "Meerut",
  "Varanasi",
  "Allahabad",
  "Amroha",
  "Moradabad",
  "Aligarh",
  "Saharanpur",
  "Noida",
  "Loni",
  "Jhansi",
  "Shahjahanpur",
  "Rampur",
  "Modinagar",
  "Hapur",
  "Etawah",
  "Sambhal",
  "Orai",
  "Bahraich",
  "Unnao",
  "Rae Bareli",
  "Lakhimpur",
  "Sitapur",
  "Lalitpur",
  "Pilibhit",
  "Chandausi",
  "Hardoi ",
  "Azamgarh",
  "Khair",
  "Sultanpur",
  "Tanda",
  "Nagina",
  "Shamli",
  "Najibabad",
  "Shikohabad",
  "Sikandrabad",
  "Shahabad, Hardoi",
  "Pilkhuwa",
  "Renukoot",
  "Vrindavan",
  "Ujhani",
  "Laharpur",
  "Tilhar",
  "Sahaswan",
  "Rath",
  "Sherkot",
  "Kalpi",
  "Tundla",
  "Sandila",
  "Nanpara",
  "Sardhana",
  "Nehtaur",
  "Seohara",
  "Padrauna",
  "Mathura",
  "Thakurdwara",
  "Nawabganj",
  "Siana",
  "Noorpur",
  "Sikandra Rao",
  "Puranpur",
  "Rudauli",
  "Thana Bhawan",
  "Palia Kalan",
  "Zaidpur",
  "Nautanwa",
  "Zamania",
  "Shikarpur, Bulandshahr",
  "Naugawan Sadat",
  "Fatehpur Sikri",
  "Shahabad, Rampur",
  "Robertsganj",
  "Utraula",
  "Sadabad",
  "Rasra",
  "Lar",
  "Lal Gopalganj Nindaura",
  "Sirsaganj",
  "Pihani",
  "Shamsabad, Agra",
  "Rudrapur",
  "Soron",
  "SUrban Agglomerationr",
  "Samdhan",
  "Sahjanwa",
  "Rampur Maniharan",
  "Sumerpur",
  "Shahganj",
  "Tulsipur",
  "Tirwaganj",
  "PurqUrban Agglomerationzi",
  "Shamsabad, Farrukhabad",
  "Warhapur",
  "Powayan",
  "Sandi",
  "Achhnera",
  "Naraura",
  "Nakur",
  "Sahaspur",
  "Safipur",
  "Reoti",
  "Sikanderpur",
  "Saidpur",
  "Sirsi",
  "Purwa",
  "Parasi",
  "Lalganj",
  "Phulpur",
  "Shishgarh",
  "Sahawar",
  "Samthar",
  "Pukhrayan",
  "Obra",
  "Niwai",
  "Patna",
  "Gaya",
  "Bhagalpur",
  "Muzaffarpur",
  "Darbhanga",
  "Arrah",
  "Begusarai",
  "Chhapra",
  "Katihar",
  "Munger",
  "Purnia",
  "Saharsa",
  "Sasaram",
  "Hajipur",
  "Dehri-on-Sone",
  "Bettiah",
  "Motihari",
  "Bagaha",
  "Siwan",
  "Kishanganj",
  "Jamalpur",
  "Buxar",
  "Jehanabad",
  "Aurangabad",
  "Lakhisarai",
  "Nawada",
  "Jamui",
  "Sitamarhi",
  "Araria",
  "Gopalganj",
  "Madhubani",
  "Masaurhi",
  "Samastipur",
  "Mokameh",
  "Supaul",
  "Dumraon",
  "Arwal",
  "Forbesganj",
  "BhabUrban Agglomeration",
  "Narkatiaganj",
  "Naugachhia",
  "Madhepura",
  "Sheikhpura",
  "Sultanganj",
  "Raxaul Bazar",
  "Ramnagar",
  "Mahnar Bazar",
  "Warisaliganj",
  "Revelganj",
  "Rajgir",
  "Sonepur",
  "Sherghati",
  "Sugauli",
  "Makhdumpur",
  "Maner",
  "Rosera",
  "Nokha",
  "Piro",
  "Rafiganj",
  "Marhaura",
  "Mirganj",
  "Lalganj",
  "Murliganj",
  "Motipur",
  "Manihari",
  "Sheohar",
  "Maharajganj",
  "Silao",
  "Barh",
  "Asarganj",
  "Indore",
  "Bhopal",
  "Jabalpur",
  "Gwalior",
  "Ujjain",
  "Sagar",
  "Ratlam",
  "Satna",
  "Murwara (Katni)",
  "Morena",
  "Singrauli",
  "Rewa",
  "Vidisha",
  "Ganjbasoda",
  "Shivpuri",
  "Mandsaur",
  "Neemuch",
  "Nagda",
  "Itarsi",
  "Sarni",
  "Sehore",
  "Mhow Cantonment",
  "Seoni",
  "Balaghat",
  "Ashok Nagar",
  "Tikamgarh",
  "Shahdol",
  "Pithampur",
  "Alirajpur",
  "Mandla",
  "Sheopur",
  "Shajapur",
  "Panna",
  "Raghogarh-Vijaypur",
  "Sendhwa",
  "Sidhi",
  "Pipariya",
  "Shujalpur",
  "Sironj",
  "Pandhurna",
  "Nowgong",
  "Mandideep",
  "Sihora",
  "Raisen",
  "Lahar",
  "Maihar",
  "Sanawad",
  "Sabalgarh",
  "Umaria",
  "Porsa",
  "Narsinghgarh",
  "Malaj Khand",
  "Sarangpur",
  "Mundi",
  "Nepanagar",
  "Pasan",
  "Mahidpur",
  "Seoni-Malwa",
  "Rehli",
  "Manawar",
  "Rahatgarh",
  "Panagar",
  "Wara Seoni",
  "Tarana",
  "Sausar",
  "Rajgarh",
  "Niwari",
  "Mauganj",
  "Manasa",
  "Nainpur",
  "Prithvipur",
  "Sohagpur",
  "Nowrozabad (Khodargama)",
  "Shamgarh",
  "Maharajpur",
  "Multai",
  "Pali",
  "Pachore",
  "Rau",
  "Mhowgaon",
  "Vijaypur",
  "Narsinghgarh",
  "Visakhapatnam",
  "Vijayawada",
  "Guntur",
  "Nellore",
  "Kurnool",
  "Rajahmundry",
  "Kakinada",
  "Tirupati",
  "Anantapur",
  "Kadapa",
  "Vizianagaram",
  "Eluru",
  "Ongole",
  "Nandyal",
  "Machilipatnam",
  "Adoni",
  "Tenali",
  "Chittoor",
  "Hindupur",
  "Proddatur",
  "Bhimavaram",
  "Madanapalle",
  "Guntakal",
  "Dharmavaram",
  "Gudivada",
  "Srikakulam",
  "Narasaraopet",
  "Rajampet",
  "Tadpatri",
  "Tadepalligudem",
  "Chilakaluripet",
  "Yemmiganur",
  "Kadiri",
  "Chirala",
  "Anakapalle",
  "Kavali",
  "Palacole",
  "Sullurpeta",
  "Tanuku",
  "Rayachoti",
  "Srikalahasti",
  "Bapatla",
  "Naidupet",
  "Nagari",
  "Gudur",
  "Vinukonda",
  "Narasapuram",
  "Nuzvid",
  "Markapur",
  "Ponnur",
  "Kandukur",
  "Bobbili",
  "Rayadurg",
  "Samalkot",
  "Jaggaiahpet",
  "Tuni",
  "Amalapuram",
  "Bheemunipatnam",
  "Venkatagiri",
  "Sattenapalle",
  "Pithapuram",
  "Palasa Kasibugga",
  "Parvathipuram",
  "Macherla",
  "Gooty",
  "Salur",
  "Mandapeta",
  "Jammalamadugu",
  "Peddapuram",
  "Punganur",
  "Nidadavole",
  "Repalle",
  "Ramachandrapuram",
  "Kovvur",
  "Tiruvuru",
  "Uravakonda",
  "Narsipatnam",
  "Yerraguntla",
  "Pedana",
  "Puttur",
  "Renigunta",
  "Rajam",
  "Srisailam Project (Right Flank Colony) Township",
  "Ludhiana",
  "Patiala",
  "Amritsar",
  "Jalandhar",
  "Bathinda",
  "Pathankot",
  "Hoshiarpur",
  "Batala",
  "Moga",
  "Malerkotla",
  "Khanna",
  "Mohali",
  "Barnala",
  "Firozpur",
  "Phagwara",
  "Kapurthala",
  "Zirakpur",
  "Kot Kapura",
  "Faridkot",
  "Muktsar",
  "Rajpura",
  "Sangrur",
  "Fazilka",
  "Gurdaspur",
  "Kharar",
  "Gobindgarh",
  "Mansa",
  "Malout",
  "Nabha",
  "Tarn Taran",
  "Jagraon",
  "Sunam",
  "Dhuri",
  "Firozpur Cantt.",
  "Sirhind Fatehgarh Sahib",
  "Rupnagar",
  "Jalandhar Cantt.",
  "Samana",
  "Nawanshahr",
  "Rampura Phul",
  "Nangal",
  "Nakodar",
  "Zira",
  "Patti",
  "Raikot",
  "Longowal",
  "Urmar Tanda",
  "Morinda, India",
  "Phillaur",
  "Pattran",
  "Qadian",
  "Sujanpur",
  "Mukerian",
  "Talwara",
  "Faridabad",
  "Gurgaon",
  "Hisar",
  "Rohtak",
  "Panipat",
  "Karnal",
  "Sonipat",
  "Yamunanagar",
  "Panchkula",
  "Bhiwani",
  "Bahadurgarh",
  "Jind",
  "Sirsa",
  "Thanesar",
  "Kaithal",
  "Palwal",
  "Rewari",
  "Hansi",
  "Narnaul",
  "Fatehabad",
  "Gohana",
  "Tohana",
  "Narwana",
  "Mandi Dabwali",
  "Charkhi Dadri",
  "Shahbad",
  "Pehowa",
  "Samalkha",
  "Pinjore",
  "Ladwa",
  "Sohna",
  "Safidon",
  "Taraori",
  "Mahendragarh",
  "Ratia",
  "Rania",
  "Sarsod",
  "Srinagar",
  "Jammu",
  "Baramula",
  "Anantnag",
  "Sopore",
  "KathUrban Agglomeration",
  "Rajauri",
  "Punch",
  "Udhampur",
  "Dhanbad",
  "Ranchi",
  "Jamshedpur",
  "Bokaro Steel City",
  "Deoghar",
  "Phusro",
  "Adityapur",
  "Hazaribag",
  "Giridih",
  "Ramgarh",
  "Jhumri Tilaiya",
  "Saunda",
  "Sahibganj",
  "Medininagar (Daltonganj)",
  "Chaibasa",
  "Chatra",
  "Gumia",
  "Dumka",
  "Madhupur",
  "Chirkunda",
  "Pakaur",
  "Simdega",
  "Musabani",
  "Mihijam",
  "Patratu",
  "Lohardaga",
  "Tenu dam-cum-Kathhara",
  "Raipur",
  "Bhilai Nagar",
  "Korba",
  "Bilaspur",
  "Durg",
  "Rajnandgaon",
  "Jagdalpur",
  "Raigarh",
  "Ambikapur",
  "Mahasamund",
  "Dhamtari",
  "Chirmiri",
  "Bhatapara",
  "Dalli-Rajhara",
  "Naila Janjgir",
  "Tilda Newra",
  "Mungeli",
  "Manendragarh",
  "Sakti",
  "Guwahati",
  "Silchar",
  "Dibrugarh",
  "Nagaon",
  "Tinsukia",
  "Jorhat",
  "Bongaigaon City",
  "Dhubri",
  "Diphu",
  "North Lakhimpur",
  "Tezpur",
  "Karimganj",
  "Sibsagar",
  "Goalpara",
  "Barpeta",
  "Lanka",
  "Lumding",
  "Mankachar",
  "Nalbari",
  "Rangia",
  "Margherita",
  "Mangaldoi",
  "Silapathar",
  "Mariani",
  "Marigaon",
  "Chandigarh",
  "Bhubaneswar",
  "Cuttack",
  "Raurkela",
  "Brahmapur",
  "Sambalpur",
  "Puri",
  "Baleshwar Town",
  "Baripada Town",
  "Bhadrak",
  "Balangir",
  "Jharsuguda",
  "Bargarh",
  "Paradip",
  "Bhawanipatna",
  "Dhenkanal",
  "Barbil",
  "Kendujhar",
  "Sunabeda",
  "Rayagada",
  "Jatani",
  "Byasanagar",
  "Kendrapara",
  "Rajagangapur",
  "Parlakhemundi",
  "Talcher",
  "Sundargarh",
  "Phulabani",
  "Pattamundai",
  "Titlagarh",
  "Nabarangapur",
  "Soro",
  "Malkangiri",
  "Rairangpur",
  "Tarbha",
  "Thiruvananthapuram",
  "Kochi",
  "Kozhikode",
  "Kollam",
  "Thrissur",
  "Palakkad",
  "Alappuzha",
  "Malappuram",
  "Ponnani",
  "Vatakara",
  "Kanhangad",
  "Taliparamba",
  "Koyilandy",
  "Neyyattinkara",
  "Kayamkulam",
  "Nedumangad",
  "Kannur",
  "Tirur",
  "Kottayam",
  "Kasaragod",
  "Kunnamkulam",
  "Ottappalam",
  "Thiruvalla",
  "Thodupuzha",
  "Chalakudy",
  "Changanassery",
  "Punalur",
  "Nilambur",
  "Cherthala",
  "Perinthalmanna",
  "Mattannur",
  "Shoranur",
  "Varkala",
  "Paravoor",
  "Pathanamthitta",
  "Peringathur",
  "Attingal",
  "Kodungallur",
  "Pappinisseri",
  "Chittur-Thathamangalam",
  "Muvattupuzha",
  "Adoor",
  "Mavelikkara",
  "Mavoor",
  "Perumbavoor",
  "Vaikom",
  "Palai",
  "Panniyannur",
  "Guruvayoor",
  "Puthuppally",
  "Panamattom",
  "Dehradun",
  "Hardwar",
  "Haldwani-cum-Kathgodam",
  "Srinagar",
  "Kashipur",
  "Roorkee",
  "Rudrapur",
  "Rishikesh",
  "Ramnagar",
  "Pithoragarh",
  "Manglaur",
  "Nainital",
  "Mussoorie",
  "Tehri",
  "Pauri",
  "Nagla",
  "Sitarganj",
  "Bageshwar",
  "Pondicherry",
  "Karaikal",
  "Yanam",
  "Mahe",
  "Agartala",
  "Udaipur",
  "Dharmanagar",
  "Pratapgarh",
  "Kailasahar",
  "Belonia",
  "Khowai",
  "Mysore",
  "Aizawl",
  "Lunglei",
  "Saiha",
  "Shillong",
  "Tura",
  "Nongstoin",
  "Imphal",
  "Thoubal",
  "Lilong",
  "Mayang Imphal",
  "Shimla",
  "Mandi",
  "Solan",
  "Nahan",
  "Sundarnagar",
  "Palampur",
  "Dimapur",
  "Kohima",
  "Zunheboto",
  "Tuensang",
  "Wokha",
  "Mokokchung",
  "Marmagao",
  "Panaji",
  "Margao",
  "Mapusa",
  "Port Blair",
  "Naharlagun",
  "Pasighat",
  "Silvassa",
];

const NUM_REGEX = /^[0-9\b]+$/;
const NUMBER_REGEX = /^([5-9]){1}([0-9]){9}?$/;
const signupURL =
  "https://payment-support.bharatpe.in/api/v1/qr/lead_form/submit";

const getSuggestions = (value) => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;

  return inputLength === 0
    ? []
    : cities.filter(
        (lang) => lang.toLowerCase().slice(0, inputLength) === inputValue
      );
};

const getURLParameter = (qrString, paramName) => {
  const qr = qrString.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  const regex = new RegExp(`[\\?&]${paramName}=([^&#]*)`);
  const results = regex.exec(qr);

  return results && results.length > 0
    ? decodeURIComponent(results[1].replace(/\+/g, " "))
    : "";
};

const getSuggestionValue = (suggestion) => suggestion;

const renderSuggestion = (suggestion) => <div>{suggestion}</div>;

const LeadGenPage = () => {
  const [addressData, setAddressData] = useState({
    mobile_no: "",
    bussiness_name: "",
    city: "",
    zipcode: "",
  });
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [mobileLengthValid, setMobileLengthValid] = useState(true);
  const [mobileRegexValid, setMobileRegexValid] = useState(true);
  const [bussinessValid, setBussinessValid] = useState(true);
  const [cityValid, setCityValid] = useState(true);
  const [zipcodeValid, setZipcodeValid] = useState(true);
  const [suggestions, setSuggestions] = useState([]);

  const checkSubmit = () => {
    if (
      addressData.bussiness_name.length < 1 ||
      addressData.mobile_no.length < 1 ||
      addressData.city < 1 ||
      addressData.zipcode.length < 6
    ) {
      setIsSubmitDisabled(true);
    } else {
      setIsSubmitDisabled(false);
    }
  };

  useEffect(() => {
    checkSubmit();
  }, [addressData]);

  const gtag_report_conversion = (url = undefined) => {
    const callback = function () {
      if (typeof url != "undefined") {
        window.location = url;
      }
    };
    window.gtag("js", new Date());
    window.gtag("config", "AW-739558385");
    window.gtag("event", "conversion", {
      send_to: "AW-739558385/F05VCJ7Yh48ZEPGH0-AC",
      event_callback: callback,
    });
    return false;
  };

  const submitFormData = () => {
    if (addressData.mobile_no.length < 10) {
      setMobileLengthValid(false);
    } else if (addressData.mobile_no.length === 10) {
      setMobileLengthValid(true);

      const valid = NUMBER_REGEX.test(addressData.mobile_no);
      if (!valid) {
        setMobileRegexValid(false);
      } else {
        setMobileRegexValid(true);
      }
    }
    if (addressData.bussiness_name.length < 5) {
      setBussinessValid(false);
    } else {
      setBussinessValid(true);
    }
    if (addressData.city.length > 1) {
      setCityValid(true);
    } else {
      setCityValid(false);
    }

    if (addressData.zipcode.length > 0 && addressData.zipcode.length !== 6) {
      setZipcodeValid(false);
    } else {
      setZipcodeValid(true);
    }

    if (
      addressData.mobile_no.length === 10 &&
      NUMBER_REGEX.test(addressData.mobile_no) &&
      addressData.bussiness_name.length >= 5 &&
      addressData.city.length > 1 &&
      addressData.zipcode.length === 6
    ) {
      let param = {
        business_name: addressData.bussiness_name,
        mobile: "91" + addressData.mobile_no,
        city: addressData.city,
        zip_code: addressData.zipcode,
        utm_source: getURLParameter(window.location.href, "utm_source") || "",
        utm_medium: getURLParameter(window.location.href, "utm_medium") || "",
        utm_campaign:
          getURLParameter(window.location.href, "utm_campaign") || "",
        gcl_id: getURLParameter(window.location.href, "gclid") || "",
      };

      axios
        .post(signupURL, param, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.status_code === 200) {
              document.getElementById("success-modal").style.display = "block";
              window.gtag("js", new Date());
              window.gtag("config", "AW-739558385");
              window.gtag("event", "conversion", {
                send_to: "AW-739558385/F05VCJ7Yh48ZEPGH0-AC",
              });

              gtag_report_conversion();
              setIsSubmitDisabled(true);
            } else {
              toast.error(response.data?.message);
            }
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error) => {
          setIsSubmitDisabled(true);
          toast.error(error);
        });
    } else {
      return;
    }
  };

  const onCityChange = (event, { newValue }) => {
    setAddressData((prevData) => ({ ...prevData, city: newValue }));
  };

  const onSuggestionsFetchRequested = ({ value }) => {
    setSuggestions(getSuggestions(value));
  };

  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const onZipCodeChange = (t) => {
    if (t) {
      const zipcode = t?.value;
      if (
        (zipcode.length <= 6 && zipcode.length === 0) ||
        NUM_REGEX.test(zipcode)
      ) {
        setAddressData((prevData) => ({ ...prevData, zipcode }));
      }
    }
  };

  const onMobileNumberChange = (t) => {
    if (t) {
      const mobile = t?.value;
      if (
        (mobile.length <= 10 && mobile.length === 0) ||
        NUM_REGEX.test(mobile)
      ) {
        setAddressData((prevData) => ({ ...prevData, mobile_no: mobile }));
      }
    }
  };

  const onAddressChange = (t) => {
    if (t) {
      const name = t?.name;
      const value = t?.value;
      setAddressData((prevData) => ({ ...prevData, [name]: value }));
    }
  };

  // ... (The rest of the code remains the same)

  return (
    <>
      <div className="container">
        <div className="login-header">
          <div className="sub-content">
            <a href="https://bharatpe.com/">
              <img src={bpLogo} className="bp-logo-header" alt="BPswipe-logo" />
            </a>
          </div>
        </div>

        <div id="short-des" className="form-wrapper">
          <img src={bpWebImg} className="header-mobile" alt="BPswipe-logo" />
          <div className="sign-card">
            <div className="left-side-sign">
              <img src={bpWebImg} alt="BPswipe-logo" />
            </div>
            <div className="right-side-sign">
              <div className="sign-right-cont">
                <div className="right-heading-sign">
                  <span className="sign-in-text">
                    Fill in the details to order your BharatPe QR now.
                  </span>
                </div>

                <div className="field w-100">
                  <Input
                    label="Mobile Number"
                    name="phone"
                    value={addressData.mobile_no}
                    onChange={({ target }) => onMobileNumberChange(target)}
                    inputMode="numeric"
                    type="text"
                    maxLength={10}
                    required
                  />
                  {!mobileLengthValid && (
                    <div className="show-error">
                      Mobile No. should be 10 digits
                    </div>
                  )}
                  {!mobileRegexValid && (
                    <div className="show-error">Enter a valid Mobile No.</div>
                  )}
                </div>
                <div className="field w-100">
                  <Input
                    label="Business Name"
                    name="bussiness_name"
                    value={addressData.bussiness_name}
                    onChange={({ target }) => onAddressChange(target)}
                    type="text"
                    maxLength={256}
                    required
                  />
                  {!bussinessValid && (
                    <div className="show-error">
                      Invalid business name. (Min 5 letters)
                    </div>
                  )}
                </div>
                <div className="field w-100">
                  <div className="material-city">
                    <Autosuggest
                      suggestions={suggestions}
                      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                      onSuggestionsClearRequested={onSuggestionsClearRequested}
                      getSuggestionValue={getSuggestionValue}
                      renderSuggestion={renderSuggestion}
                      inputProps={{
                        placeholder: "City",
                        value: addressData.city,
                        onChange: onCityChange,
                        required: true,
                      }}
                    />
                    {!cityValid && (
                      <div className="show-error">
                        Please enter a valid city
                      </div>
                    )}
                  </div>
                </div>
                <div className="field w-100">
                  <Input
                    label="Pincode"
                    name="pincode"
                    value={addressData.zipcode}
                    onChange={({ target }) => onZipCodeChange(target)}
                    inputMode="numeric"
                    type="text"
                    maxLength={6}
                    required
                  />
                  {!zipcodeValid && (
                    <div className="show-error">
                      Please enter a valid pincode
                    </div>
                  )}
                </div>
                <div className="disclaimer">
                  By submitting this form, I give consent to receive updates
                  from BharatPe via WhatsApp, SMS or Phone call.
                </div>
                <input
                  type="submit"
                  className="submitBtn"
                  value="Submit"
                  onClick={() => submitFormData()}
                  disabled={isSubmitDisabled}
                />
              </div>
            </div>
          </div>
        </div>
        <section className="section cards-container">
          <div className="section_header">
            <span className="sub-title">The QR for Bharat’s Businesses</span>
            <span className="title">Order BharatPe QR</span>
          </div>
          <div className="section_content">
            <div className="section_content_cards_ctn">
              <div className="benefit-card blue">
                <span className="icon">
                  <img src={orderQrIcon} alt="R" />
                </span>
                <span className="title">Order QR for Free</span>
                <span className="description">
                  Free Doorstep Delivery of QR Stickers
                </span>
              </div>
              <div className="benefit-card pink">
                <span className="icon">
                  <img src={oneQrIcon} alt="R" />
                </span>
                <span className="title">One QR for all payments</span>
                <span className="description">
                  Accept payments from 180+ UPI Apps
                </span>
              </div>
            </div>
            <div className="section_content_cards_ctn">
              <div className="benefit-card yellow">
                <span className="icon">
                  <img src={instantDeliveryIcon} alt="R" />
                </span>
                <span className="title">Instant Settlement</span>
                <span className="description">
                  On-demand and automatic settlement option
                </span>
              </div>
              <div className="benefit-card green">
                <span className="icon">
                  <img src={verifiedIcon} alt="R" />
                </span>
                <span className="title">100% Safe</span>
                <span className="description">
                  Trusted by 13+ million merchants
                </span>
              </div>
            </div>
          </div>
        </section>

        <section className="section about-us-container">
          <div className="flex flex-column">
            <a href="https://bharatpe.com/">
              <img className="logo" src={bpLogo} alt="BPswipe-logo" />
            </a>
            <span className="flex app-link">
              <a
                href="https://play.google.com/store/apps/details?id=com.bharatpe.app&amp;hl=en_IN"
                target="_blank"
                rel="noreferrer"
              >
                <img src={googlePlayIcon} alt="google-play" />
              </a>
              <a
                href="https://apps.apple.com/in/app/bharatpe/id1329385873"
                target="_blank"
                rel="noreferrer"
              >
                <img src={appStoreIcon} alt="google-play" />
              </a>
            </span>
          </div>

          <div className="about-us-container_items">
            <div className="about-us-container_items_clubbed">
              <div className="flex flex-column">
                <span className="link-header">GENERAL</span>
                <a className="link mb-16" href="https://bharatpe.com/about">
                  About Us
                </a>
                <a
                  className="link mb-16"
                  href="https://bharatpe.com/press"
                  target="_blank"
                  rel="noreferrer"
                >
                  Press
                </a>
                <a
                  className="link"
                  target="_blank"
                  rel="noreferrer"
                  href="https://bharatpe.com/contact"
                >
                  Contact Us
                </a>
              </div>
              <div className="flex flex-column">
                <span className="link-header">LEGAL</span>
                <a
                  className="link mb-16"
                  href="https://bharatpe.com/terms"
                  target="_blank"
                  rel="noreferrer"
                >
                  Terms & Conditions
                </a>
                <a
                  className="link mb-16"
                  href="https://bharatpe.com/privacy-policy"
                  target="_blank"
                  rel="noreferrer"
                >
                  Privacy Policy
                </a>
                <a
                  className="link"
                  href="https://bharatpe.com/grievance-redressal-policy"
                  target="_blank"
                  rel="noreferrer"
                >
                  Grievance & Redressal
                </a>
              </div>
            </div>
            <div className="about-us-container_items_clubbed">
              <div className="flex flex-column">
                <span className="link-header">Resources</span>
                <a
                  className="link mb-16"
                  href="https://bharatpe.com/build-with-bharatpe"
                  target="_blank"
                  rel="noreferrer"
                >
                  Build with BharatPe
                </a>
                <a
                  className="link mb-16"
                  target="_blank"
                  rel="noreferrer"
                  href="https://bharatpe.com/transforming-bharat-listing"
                >
                  Transforming BharatPe
                </a>
                <a
                  className="link"
                  href="https://bharatpe.com/merchant-stories-listing"
                  target="_blank"
                  rel="noreferrer"
                >
                  Merchant Stories
                </a>
              </div>
              <div className="flex flex-column">
                <span className="link-header">FOLLOW US</span>
                <a
                  className="link flex flex-center mb-16"
                  href="https://www.linkedin.com/company/bharatpe/about/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    className="social-media-icon"
                    src={linkedinIcon}
                    alt=""
                  />
                  <span>linkedin</span>
                </a>
                <a
                  className="link flex flex-center mb-16"
                  href="https://www.facebook.com/BharatPeIndia/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    className="social-media-icon"
                    src={facebookIcon}
                    alt=""
                  />
                  <span>facebook</span>
                </a>
                <a
                  className="link flex flex-center mb-16"
                  href="https://www.instagram.com/bharat.pe/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    className="social-media-icon"
                    src={instagramIcon}
                    alt=""
                  />
                  <span>instagram</span>
                </a>
                <a
                  className="link flex flex-center"
                  href="https://twitter.com/bharatpeindia"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img className="social-media-icon" src={twitterIcon} alt="" />
                  <span>twitter</span>
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div className="dialog" id="success-modal">
        <div className="dialog-backdrop">&nbsp;</div>
        <div className="thankyou-modal">
          <span className="text">Thank You!</span>
          <img
            src={cross}
            className="success-modal-close-btn"
            onClick={() => {
              window.location.href = "/";
            }}
            alt="closeImg"
          />
          <span className="sub-text">for expressing interest in</span>
          <img src={bpblk} className="icon" alt="thanks" />
          <span className="sub-text">Our team will contact you shortly!</span>
          <iframe
            width="100%"
            height="315"
            className="youtube-video-iframe"
            src="https://www.youtube.com/embed/J66o2WkK1P8?si=kQXM6YjAnwtbrKSM&amp;controls=0"
            title="YouTube video player"
            frameborder="0"
            allowfullscreen
          ></iframe>

          <div class="get-download-button">
            <a
              href="https://play.google.com/store/apps/details?id=com.bharatpe.app&amp;hl=en_IN"
              target="_blank"
              rel="noreferrer"
            >
              <img src={googlePlayIcon} alt="google-play" />
            </a>
            <a
              href="https://apps.apple.com/in/app/bharatpe/id1329385873"
              target="_blank"
              rel="noreferrer"
            >
              <img src={appStoreIcon} alt="google-play" />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeadGenPage;
